const deleteProductUnit = (NOMBRE)=> {
    var old = JSON.parse(localStorage.getItem("carrito"))
    var i = 0;
    for (; i < old.length ;){
        if (old[i].desc === NOMBRE){
            old[i].cant = old[i].cant-1
        }
        i++
    }
    localStorage.setItem("carrito", JSON.stringify(old))
}

export { deleteProductUnit }